export default {
  ButtonName: {
    Follow: 'Chọn mẫu',
    Cancel: 'Hủy',
    View: 'Xem trước',
    Agree: 'Đồng ý',
    Util: 'Tiện ích',
    Default: 'Lấy lại mặc định',
    ViewTry: 'Xem thử',
    Save: 'Cất',
  },
  ScreenName: {
    TitleName: 'Tùy chỉnh mẫu',
    Help: 'Trợ giúp',
    SetLayOut: 'Tùy chỉnh giao diện',
  },

  TabColumnsReport: {},
  TabRowsReport: {},
  TabInfoAdd: {
    UpDownFont: 'Tăng giảm font chữ',
    ShowRowPlus: 'Hiển thị dòng cộng khi có phát sinh 2 dòng trở lên',
    ShowRowSum: 'Hiển thị dòng tổng cộng ở phía trên',
  },
  PopupShowContent: {
    SetContentShow: 'Thiết lập nội dung hiển thị',
    ChooseDefault: 'Cách hiển thị cột nội dung',
    ResultShow: 'Xem trước',
    DataSource: 'Nguồn dữ liệu',
    ChapterCode: 'Mã chương',
    ChapterName: 'Tên chương',
    SubBudgetCode: 'Mã tiểu mục',
    SubBudgetName: 'Tên tiểu mục',
    SubCode: 'Mã khoản',
    SubName: 'Tên khoản',
    TextNote: 'vào trường thông tin bên danh sách ',
    NoteItem: '+ Thông tin lấy trên nguồn dữ liệu viết là ',
    NoteItemFinal: '+ Những thông tin khác gõ tự do',
  },
  PopupHideMoney: {},
  ColumnsReportDetail: {},

  ReportInterface: {
    ReportB02a: {
      top: {
        left: {
          row1: 'Mã chương: 800',
          row2: 'Đơn vị: UBND Xã MISA',
          row3: 'Mã ĐVQHNS: 3028932',
          row4: 'Mã cấp NS: 4',
        },
        right: {
          row1: 'Mẫu số 20c',
          row2: 'Ký hiệu: 02a-SDKP/ĐVDT',
        },
      },
      title:
        'BẢNG ĐỐI CHIẾU TÌNH HÌNH SỬ DỤNG KINH PHÍ NGÂN SÁCH BẰNG HÌNH THỨC RÚT DỰ TOÁN TẠI KHO BẠC NHÀ NƯỚC'.toUpperCase(),
      subTitle: {
        row1: `Quý ... Năm ...`,
      },
      info: {
        row1: 'Mã ĐVQHNS:',
        row2: 'Mã chương: 800',
        row3: 'Mã cấp NS:',
      },
    },
  },

  DeleteReport: {
    DeleteReport: 'Xóa mẫu báo cáo',
    ConfirmDeleteReport: 'Bạn có chắc chắn muốn xóa <strong>"{0}"</strong> không?',
  }
};
